import {getViewportGeometry} from "../src/viewport-geometry";
import {elementsGeometry} from "../src/elements-geometry";
import {throttle} from "../src/throttle";

const $ = jQuery;

const body = $('body');
const stickyElements = $('.wp-block-iamntz-gutenberg-toc, .ntz-gutenberg-hero-of-the-day').filter('[class*="is-style-sticky-on"]').add('.js-ntz-sticky');

const toc = $('.wp-block-iamntz-gutenberg-toc');
const triggerButton = '<span class="iamntz-gutenberg-toc--toggler-wrapper"><span class="iamntz-gutenberg-toc--toggler"><span></span></span></span>';

toc.wrapInner('<div />');
toc.prepend(triggerButton);

$(document).on('click', '.iamntz-gutenberg-toc--toggler-wrapper', (e) => {
    e.preventDefault();
    body.toggleClass('toc-is-smart-hidden');
});

body.addClass('smart-toc-hidden-init toc-is-smart-hidden');

// click outside ToC will collapse it
$(document).on('click', (e) => {
    const target = $(e.target);

    if (target.is('.iamntz-gutenberg-toc--toggler-wrapper') || target.closest('.iamntz-gutenberg-toc--toggler-wrapper').length) {
        return;
    }

    body.addClass('toc-is-smart-hidden');
});


stickyElements.each((i, stickyElement) => {
    const clone = $(stickyElement).clone(true);
    clone.addClass('is-sticky-clone').insertAfter(stickyElement);

    setTimeout(() => $(window).trigger('cucu-tweaks/start-timer-init', [clone]), 100);
});


const maybeStick = () => {
    const stuckClass = 'is-stuck';
    const unstuckClass = 'is-unstuck';
    const elements = elementsGeometry(stickyElements, getViewportGeometry());

    elements.forEach(geometry => {
        if (geometry.outside && geometry.after_fold) {
            geometry.el.addClass(stuckClass)
            geometry.el.removeClass(unstuckClass)
        } else {
            geometry.el.removeClass(stuckClass)
            geometry.el.addClass(unstuckClass)
        }
    });
};

const maybeStickRAF = () => {
    throttle(requestAnimationFrame(maybeStick));
};

$(window).on('resize.ntz-hero-of-the-day-sticky', maybeStickRAF);
$(window).on('scroll.ntz-hero-of-the-day-sticky', maybeStickRAF);

maybeStick();

$(window).on('ntz-image-loaded', maybeStickRAF)